
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ef-quote-form",
      function () {
        return require("private-next-pages/ef-quote-form/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ef-quote-form"])
      });
    }
  